import {
  CardActions,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from "@material-ui/core";
import { DateTimePicker } from "@material-ui/pickers";
import React from "react";
import { connect } from "react-redux";
import StyledButton from "../../Page/Landing/components/StyledButton";
import actions from "../../redux/actions";

function ScheduleModal(props) {
  const {
    isFetching,
    setModalData,
    resetModal,
    isOpen,
    modalData,
    scheduleByTeacher,
  } = props;

  const onClose = () => {
    resetModal();
  };
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogContent>
        <Typography variant="h6">
          {modalData.mode === "schedule" ? "زمانبندی" : "زمانبندی مجدد"}
        </Typography>

        <br />
        <br />
        <DateTimePicker
          autoOk
          disabled={isFetching}
          minDate={new Date()}
          mess
          inputVariant="outlined"
          label="از"
          minutesStep={30}
          cancelLabel="لغو"
          okLabel="تنظیم"
          fullWidth
          ampm={false}
          format="yyyy/MM/dd"
          labelFunc={(date) => (date ? date.format("jYYYY/jMM/jDD HH:mm") : "")}
          value={
            new Date(modalData.from) < new Date() ? new Date() : modalData.from
          }
          onChange={(date) => {
            setModalData({
              ...modalData,
              from: new Date(date),
              to: new Date(
                new Date(date).getTime() + modalData.duration * 60000
              ),
            });
          }}
        />
        <br />
        <br />
      </DialogContent>
      <CardActions>
        <StyledButton variant="outlined" onClick={onClose}>
          لغو
        </StyledButton>
        <div style={{ flexGrow: 1 }} />
        <StyledButton
          onClick={(_) => scheduleByTeacher()}
          variant="contained"
          color="primary"
        >
          {isFetching ? (
            <CircularProgress size="1.2rem" color="#ffffff" />
          ) : (
            "ثبت"
          )}
        </StyledButton>
      </CardActions>
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  isOpen: state.dashboard.scheduleModal.isOpen,
  modalData: state.dashboard.scheduleModal.data,
  isFetching: state.dashboard.schedule.fetching,
});
const mapDispatchToProps = (dispatch) => ({
  scheduleByTeacher: () =>
    dispatch(actions.dashboard.schedule.teacherSchedule()),
  setModalData: (data) =>
    dispatch(actions.dashboard.scheduleModal.setData(data)),
  resetModal: () => dispatch(actions.dashboard.scheduleModal.reset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleModal);
